
import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbPreCadastro extends AppService {
  abstract opConta: string[];

  abstract salvarPreCadastro(obj): Observable<any>;
  abstract unidadePreCadastro(obj): Observable<any>;
  abstract veiculoPreCadastro(obj): Observable<any>;
  abstract aprovarPreCadastro(aprovado, id): Observable<any>;
  abstract getAllMarcasVeiculosPreCadastro(tipoVeiculo: String): Observable<any>;
  abstract getPessoaPreCadastro(id: number): Observable<any>;
  abstract getAllPessoaPreCadastroPendentes(): Observable<any>;
  abstract getAllPessoaPreCadastroByFilter(filter: AppFilter): Observable<any>;
  abstract getAllMoradoresByPessoaPreCadastro(uuid: number): Observable<any>;
  abstract finalizarPreCadastro(uuid: string);
  abstract getVeiculosPreCadastroByPessoaPreCadastroId(uuid: number);
  abstract getUnidadesPreCadastroByPessoaPreCadastroId(uuid: number);
  abstract excluirPessoaPreCadastro(id: number);
  abstract excluirUnidadePreCadastro(id: number);
  abstract excluirVeiculoPreCadastro(id: number);
  abstract emailDuplicado(id: number, email: string): Observable<any>;
}
